import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 8,
        width: '100%',
    },

    imageZone: {
        position: 'relative',
        width: '100%',
        height: 130,
        borderRadius: theme.radius,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `2px dashed ${theme.colors.grey_light}`,
        backgroundColor: theme.colors.grey_background,

        '&:hover $imageOverlay': {
            opacity: 1,
        },
    },

    imageThumb: {
        width: '100%',
        height: '100%',
        objectFit: 'contain' as const,
        display: 'block',
        background: theme.colors.grey_background,
    },

    imagePlaceholder: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    imageOverlay: {
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(70, 40, 120, 0.72)',
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
        opacity: 0,
        transition: 'opacity 0.2s ease',
        gap: theme.spacing(2),
        fontSize: 12,
        textAlign: 'center' as const,
        padding: `0 ${theme.spacing(3)}`,
    },
}));
